import React from "react";
import Navbar from "./mainsections/Navbar";
import Footer from "./mainsections/Footer";
export default function MainLayout(props) {
  return (
    <div>
      {props.navbar && <Navbar navProps={props.navProps} />}
      {props.children}
      {props.footer && <Footer />}
    </div>
  );
}
